import { render, staticRenderFns } from "./TabPFA.vue?vue&type=template&id=43fc9585"
import script from "./TabPFA.vue?vue&type=script&lang=js"
export * from "./TabPFA.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports